define("tmds/symbols/SimpleFillSymbol", [
	"jquery",
	"./Symbol",
	"./SimpleLineSymbol",
	"./utils",
	"../validator"
], function($, Symbol, SimpleLineSymbol, utils, validator) {
	"use strict";
	
	var constants = {
		STYLE_NULL: "none",
		STYLE_SOLID: "solid"
	};
	
	/**
	 * construct a new SimpleFillSymbol
	 * @param options {Object} option object with below structure
	 * 		{
	 * 			style: 'solid',
	 * 			color: [255,0,0,0.5],
	 * 			outline: {
	 * 				style: 'solid',
	 * 				color: [124,124,0,0.5],
	 * 				width: 2
	 * 			}
	 * 		}
	 * @note all option members are optional
	 */
	var SimpleFillSymbol = function(options) {
		
		Symbol.call(this, options);
		
		/**
		 * default line symbol: solid black thin line
		 */
		this.style = 'solid';
		this.color = [0,0,0,1];
		this.outline = new SimpleLineSymbol();
		
		if(options != undefined) {
			
			if (validator.isDataObject(options)) {
			
				if(options.style != undefined) 
						setStyle.call(this, options.style);
				
				if(options.color != undefined) 
						setColor.call(this, options.color);
				
				if(options.outline != undefined) 
						setOutline.call(this, new SimpleLineSymbol(options.outline));
			}
			else {
			 	throw new Error('Invalid options values - ' + options + ' passed');
		 	}
		}
	};
	
	/**
	 * set the fill symbol color
	 * @param color {Array} [r,g,b,a]
	 * @return the symbol itself
	 */
	function setColor(color) {
		
		var _color = utils.toColorArray(color);

		if(_color === false) {
			
			throw new Error('Invalid color value - ' + color + ' passed');
		}
		
		this.color = _color;
		return this;
	}
	
	/**
	 * set the fill symbol style
	 * @param style {String}
	 * @return the symbol itself
	 */
	function setStyle(style) {
		
		if(! validator.isValidFillStyle(style)) {
			
			throw new Error('Invalid style value - ' + style + ' passed');
		}
		
		this.style = style;
		return this;
	}
	
	/**
	 * set the line symbol width
	 * @param outline {tmds.symbols.SimpleLineSymbol} new outline
	 * @return the symbol itself
	 */
	function setOutline(outline) {
		
		if(! validator.isInstanceOf(outline, SimpleLineSymbol)) {
			
			throw new Error('Given value is not an instance of SimpleLineSymbol.');
		}
		
		this.outline = outline;
		return this;
	}
	
	/**
	 * convert SimpleFillSymbol object to JSON representation
	 */
	function toJson() {
		return {
			type: this.type,
			style: this.style,
			color: this.color,
			outline: this.outline.toJson()
		};
	}
	
	/**
	 * define static methods
	 */
	SimpleFillSymbol.styles = function() { return constants; };
	
	// SimpleFillSymbol inherits Symbol with some extensions
	SimpleFillSymbol.prototype = $.extend(Object.create(Symbol.prototype), {
		
		declaredClass: "tmds.symbols.SimpleFillSymbol",
		type: "SimpleFillSymbol",
		'setColor' : setColor,
		'setStyle' : setStyle,
		'setOutline' : setOutline,
		'toJson' : toJson
	});
	
	return SimpleFillSymbol;
});